module.exports = __webpack_public_path__ + "img/16.9186fdef.png";